/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Spin, Button, Space } from 'antd';
import { SecurityScanOutlined } from '@ant-design/icons';
import Bread from '../../../components/breadcrumb';
import { routeUsuarioInfo } from '../../../utils/routesBread';
import FormUsuario from '../form';
import { fetchUsuarioById } from '../../../actions/user';

const InfoUsuario = () => {
  const { usuario, isLoading } = useSelector((state) => state.usuarioReducer);
  const [form, setForm] = useState({
    email: '',
    nombre: '',
    usuario: '',
    celular: '',
    puesto: '',
    empresa: '',
    telegram: ''
  });
  const [disabled, setDisabled] = useState(true);
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const irAPrivilegios = () => {
    navigate(`/usuario/${id}/privilegios`);
  };

  useEffect(() => {
    dispatch(fetchUsuarioById(id));
  }, []);
  useEffect(() => {
    setForm({
      email: usuario && usuario.email,
      nombre: usuario && usuario.nombre,
      usuario: usuario && usuario.usuario,
      celular: usuario && usuario.celular,
      puesto: usuario && usuario.puesto,
      empresa: usuario && usuario.empresa && usuario.empresa.nombre
    });
  }, [usuario]);

  return (
    <div>
      <div className="header-nav">
        <Bread routes={routeUsuarioInfo} />
        <Space>
          <Button
            type="primary"
            icon={<SecurityScanOutlined />}
            onClick={irAPrivilegios}
            disabled={isLoading || !usuario}
          >
            Gestionar Privilegios
          </Button>
        </Space>
      </div>
      <div className="info-container">
        {isLoading
          ? (
            <div className="container-spin">
              <Spin tip="Cargando..." />
            </div>
          )
          : (
            <>
              {usuario === undefined
                ? (
                  <p className="info-container__nothing">Los detalles del usuario no se encontrarón</p>
                )
                : (
                  <FormUsuario
                    data={form}
                    disabled={disabled}
                    setDisabled={setDisabled}
                  />
                )}
            </>
          )}
      </div>
    </div>
  );
};

export default InfoUsuario;
